<template>
    <div>
        <base-header :type="gradientType" class="pb-6 pb-8 pt-5 pt-md-8">
             <base-dropdown v-if="activeModules.length > 1">
               <base-button slot="title" :type="buttonType" class="dropdown-toggle">
                 {{_.startCase(currentProfile)}}
               </base-button> 
               <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)" class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="col-md-12">
                              <div class="card-body">
                                  <auto-rep-table :key="formKey" :accessRights="accessRights"></auto-rep-table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import AutoRepTable from '../Tables/AutoRepTable.vue'
  import FilterBar from './../FilterBar'
  import { mapState, mapActions } from 'vuex'
  import secureStorage from '../../controllers/secureStorage';

  export default {
      data: function(){
          return {
              formKey: 0,
              activeModules: [],
              profileId: null,
              accessRights: [],
              gradientType: "instore",
              buttonType: "danger",
              statusKey: 0
          }
      },
      watch:{
        $route: async function (to, from) {
            await this.loadPage();
        }
      },
      mounted: async function(){
         this.loadPage()
      },
      computed: {
        ...mapState(['currentProfile','currentApiURL', 'endPoint', 'parameters']),
      },
      components:{
          AutoRepTable, FilterBar
      },
      methods:{
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        async loadPage(){
             var providedFilter = this.$route.query.type
  
            var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-007', null, null)
            this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
           
            
            if( this.activeModules.length > 0 ){
                var profile = _.snakeCase(this.activeModules[0].name)
                this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
            } else {
                this.setCurrentProfile(null,null);
                this.formKey++
            }

            if(providedFilter.includes("U-") || providedFilter.includes("UG-")){
                this.gradientType = "instore"
                this.buttonType = "danger"
            }
            else{
               this.gradientType = "instore"
               this.buttonType = "success"
            }

        },
        async setCurrentProfile(profile, id){

            console.log("Profile :: ", profile)
            this.profileId = id
            var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
            if (_.isEmpty(accessRightsRequest.access_rights) == false){
                this.accessRights = accessRightsRequest.access_rights[id]
            }else {
                this.accessRights = []
            }
            this.updateCurrentProfile(profile)
            this.statusKey++;
            this.formKey++;
            // this.updateCurrentProfile(profile)
        },
      }
  };
</script>


<style>
</style>
